<template>
    <access-denied v-if="accessDenied" title="regiao" />
    <div id="main" v-else>
        <loader v-if="isLoading" />
        <div class="page">
            <alert-container :messages="msgs" />
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t('regiao') }}
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{ $t($route.meta.contexto) }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: `${$route.meta.abrev}-regiao-list`,
                                            })
                                        "
                                        >{{ $t('regiao') }}</a
                                    >
                                </li>
                                <li>
                                    <a aria-current="page">{{
                                        $route.params.id
                                            ? $route.params.id + ' - ' + regiao.descricao
                                            : $t('novo')
                                    }}</a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: `${$route.meta.abrev}-regiao-list`,
                                })
                            "
                        >
                            {{ $t('voltar') }}
                        </button>
                        <button
                            v-if="
                                (!regiaoIntegracao && !isUpdate && permissao.create) ||
                                (!regiaoIntegracao && isUpdate && permissao.update)
                            "
                            class="save-btn"
                            type="button"
                            @click="salvar()"
                            :disabled="isSaving"
                        >
                            {{ $t('salvar') }}
                            <button-loader :isSaving="isSaving" />
                        </button>
                    </div>
                </div>
                <br />
                <div class="form-columns-fit page-container">
                    <div class="columns is-flex-wrap">
                        <div class="column is-2">
                            <v-input
                                :id="generateId(9)"
                                ref="idErpInput"
                                v-model="regiao.idregiaoerp"
                                placeholder="placeholder-preencha"
                                :maxlength="30"
                                title="codigo"
                                required
                                tooltipLabel="cod-ref"
                                :invalid="!regiao.idregiaoerp"
                                uppercase
                                :disabled="regiaoIntegracao"
                            />
                        </div>
                        <div
                            class="column"
                            :class="
                                $route.meta.abrev == 'ven' || $route.meta.abrev == 'agro'
                                    ? ' is-10'
                                    : ' is-8'
                            "
                        >
                            <v-input
                                :id="generateId(1)"
                                ref="descricaoInput"
                                v-model="regiao.descricao"
                                placeholder="placeholder-preencha"
                                :maxlength="50"
                                title="descricao"
                                tooltipLabel="informacao-descricao-regiao"
                                :tooltipMultilined="true"
                                :required="true"
                                tooltipSize="is-small"
                                msg="msg-campo-obrigatorio"
                                :invalid="!regiao.descricao"
                                uppercase
                                :disabled="regiaoIntegracao"
                            />
                        </div>
                        <div class="column is-4" v-show="$route.meta.abrev == 'ven' || $route.meta.abrev == 'agro'">
                            <vss-select
                                :id="generateId(2)"
                                ref="empresaSelect"
                                :searchable="false"
                                :options="empresas"
                                title="empresa"
                                tooltipLabel="informacao-empresa-regiao"
                                :tooltipMultilined="true"
                                tooltipSize="is-small"
                                :required="true"
                                v-model="empresa"
                                class="no-clear"
                                :loading="empresasLoading"
                                @onBlurFunction="sendIsChanged()"
                                :disabled="regiaoIntegracao"
                            />
                        </div>
                        <div class="column is-4" v-show="$route.meta.abrev == 'ven' || $route.meta.abrev == 'agro'">
                            <v-input
                                :id="generateId(3)"
                                v-model="regiao.reajustecif"
                                placeholder="placeholder-preencha"
                                :msg="msgPorcentagemInvalida"
                                title="reajuste-por-cif"
                                :invalid="invalidPorcentagemCif"
                                :onBlurFunction="validatePorcCif"
                                tooltipLabel="informacao-reajuste-cif-regiao"
                                :tooltipMultilined="true"
                                :maxlength="6"
                                ref="reajusteCifInput"
                                validchars="0123456789."
                                :tooltipPosition="isMobile ? 'is-bottom' : 'is-right'"
                                tooltipSize="is-small"
                                icon="percent"
                                porcentagem
                                :disabled="regiaoIntegracao"
                            />
                        </div>
                        <div class="column is-4" v-show="$route.meta.abrev == 'ven' || $route.meta.abrev == 'agro'">
                            <v-input
                                :id="generateId(4)"
                                v-model="regiao.reajustefob"
                                placeholder="placeholder-preencha"
                                :msg="msgPorcentagemInvalida"
                                :invalid="invalidPorcentagemFob"
                                :onBlurFunction="validatePorcFob"
                                :maxlength="6"
                                ref="reajusteFobInput"
                                validchars="0123456789."
                                tooltipLabel="informacao-reajuste-fob-regiao"
                                :tooltipMultilined="true"
                                :tooltipPosition="isMobile ? 'is-bottom' : 'is-right'"
                                title="reajuste-por-fob"
                                tooltipSize="is-small"
                                icon="percent"
                                porcentagem
                                :disabled="regiaoIntegracao"
                            />
                        </div>
                        <div class="column is-4" v-show="$route.meta.abrev == 'ven' || $route.meta.abrev == 'agro'">
                            <v-input
                                :id="generateId(5)"
                                v-model="regiao.valorminimofob"
                                placeholder="placeholder-preencha"
                                ref="valorMinimoFobInput"
                                validchars="0123456789."
                                tooltipLabel="informacao-valor-minimo-pedido-fob-regiao"
                                :tooltipMultilined="true"
                                :tooltipPosition="isMobile ? 'is-bottom' : 'is-left'"
                                title="valor-minimo-fob"
                                tooltipSize="is-small"
                                :disabled="regiaoIntegracao"
                            />
                        </div>
                        <div class="column is-4" v-show="$route.meta.abrev == 'ven' || $route.meta.abrev == 'agro'">
                            <v-input
                                :id="generateId(6)"
                                v-model="regiao.valorminimocif"
                                placeholder="placeholder-preencha"
                                ref="valorMinimoCifInput"
                                validchars="0123456789."
                                tooltipLabel="informacao-valor-minimo-pedido-cif-regiao"
                                :tooltipMultilined="true"
                                :tooltipPosition="isMobile ? 'is-bottom' : 'is-right'"
                                title="valor-minimo-cif"
                                tooltipSize="is-small"
                                :disabled="regiaoIntegracao"
                            />
                        </div>
                        <div class="column is-4" v-show="$route.meta.abrev == 'ven' || $route.meta.abrev == 'agro'">
                            <v-input
                                :id="generateId(7)"
                                v-model="regiao.ticketmedio"
                                placeholder="placeholder-preencha"
                                ref="ticketMedioInput"
                                validchars="0123456789."
                                tooltipLabel="informacao-ticket-medio-regiao"
                                :tooltipMultilined="true"
                                tooltipPosition="is-right"
                                title="validacao-ticket-medio"
                                tooltipSize="is-small"
                                :disabled="regiaoIntegracao"
                            />
                        </div>
                        <div class="column" :class="$route.meta.abrev == 'ven' || $route.meta.abrev == 'agro' ? ' is-6' : ' is-2'">
                            <vss-select
                                :id="generateId(8)"
                                ref="situacaoSelect"
                                :options="situacoes"
                                v-model="situacao"
                                :mlLabels="true"
                                :disabled="regiao.idregiao == null || regiaoIntegracao"
                                title="situacao"
                                @onBlurFunction="sendIsChanged()"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EmpresaService from '@/services/vendas/empresa/EmpresaService';
import SelectBox from '@/components/shared/form/SelectBox.vue';
import RegiaoService from '@/services/RegiaoService';
import RegiaoValidation from '@/services/validations/RegiaoValidation';
import Message from '@/models/Message';

export default {
    components: {
        SelectBox,
    },
    beforeRouteLeave(to, from, next) {
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    data() {
        return {
            regiaoIntegracao: this.$store.state.user.tabelasERPWebServer.includes('REGIAO'),
            isSaving: false,
            tipos: ['LPS', 'Distribuídora', 'Indústria', 'Banderia', 'Rede'],
            empresaService: new EmpresaService(this.$http, this.$router),
            regiao: {
                idregiao: null,
                idregiaoerp: null,
                idempresa: null,
                descricao: null,
                situacao: null,
                reajustecif: 0,
                reajustefob: 0,
                valorminimofob: 0,
                valorminimocif: 0,
                ticketmedio: 0,
            },
            msgs: [],
            editable: false,
            abaSelecionada: 0,
            abas: ['dados', 'contratos'],
            contratos: [],
            situacoes: [
                { label: 'inativo', id: 0 },
                { label: 'ativo', id: 1 },
            ],
            situacao: { label: 'ativo', id: 1 },
            isUpdate: false,
            // @84479 - Conteúdo padrão das options de listagem é o todos
            empresas: [{ id: 0, label: 'Todos' }],
            empresa: { id: 0, label: 'Todos' },
            msgPorcentagemInvalida: 'porcentagem-invalida',
            invalidPorcentagemCif: false,
            invalidPorcentagemFob: false,
            isMobile: false,
            empresasLoading: false,
            isChanged: false,
            isLoading: false,
            isLoadingEdit: false,
            accessDenied: false,
            permissao: null,
            isVenda: "vendas" === this.$route.meta.contexto,
            isAgro: "agro" === this.$route.meta.contexto,
            abrev: null,
        };
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.isChanged = false;
        this.service = new RegiaoService(this.$http, this.$router);
        this.validation = new RegiaoValidation(this.msgs);
        this.carregarEmpresas('');

        this.abrev = this.$route.meta.abrev

        if (this.$route.meta.abrev == 'ven') {
            this.permissao = this.hasPermissionAccess('vendas', 'clientes', 'ven-regiao');
        } else if (this.$route.meta.abrev == 'agro') {
            this.permissao = this.hasPermissionAccess('agro', 'clientes', 'agro-regiao');
        } else if (this.$route.meta.abrev == 'pro') {
            this.permissao = this.hasPermissionAccess('promotor', 'cadastros', 'regioes');
        }

        if (!this.permissao.read) {
            this.accessDenied = true;
        } else {
            if (this.regiao != null && this.regiao != {}) {
                this.editable = true;
            }

            if (!this.isUpdate && !this.permissao.create) {
                this.accessDenied = true;
            }

            if (this.$route.params.id) {
                this.editable = false;
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    watch: {
        regiao: {
            deep: true,
            handler: function () {
                if (!this.isLoadingEdit && !this.isLoading) {
                    this.isChanged = true;
                }
            },
        },
    },
    methods: {
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t('msg-tem-certeza-alteracoes'),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        sendIsChanged() {
            if (!this.isLoadingEdit && !this.isSaving) this.isChanged = true;
        },
        generateId(numberId) {
            return this.$route.name + '-' + numberId;
        },
        getPlaceholderTipo() {
            if (!this.regiao.tipo) {
                return this.$t('cidade-do-promotor-placeholder');
            } else {
                return this.regiao.tipo;
            }
        },
        carregarDados(id) {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.service
                .find(id)
                .then((body) => {
                    if (body.content) {
                        this.regiao = body.content;
                        this.situacao = this.situacoes[this.regiao.situacao];
                        this.empresa = this.empresas.find(
                            (e) => parseInt(e.id) == parseInt(this.regiao.idempresa)
                        );
                        if (!this.empresa) {
                            this.empresa = {
                                id: this.$store.state.user.empresas[0].id,
                                label: this.$store.state.user.empresas[0].nome,
                            };
                        }
                    } else {
                        this.$router.push({
                            name:
                                this.isVenda || this.isAgro
                                    ? `${this.abrev}-regiao-new`
                                    : 'new-regiao',
                        });
                    }
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message('error', 'msg-erro-load', true));
                })
                .finally((_) => {
                    this.isLoading = false;
                    this.isLoadingEdit = false;
                });
        },
        updateSituacao(situacao) {
            if (situacao && situacao.id != null) {
                this.regiao.situacao = situacao.id;
                this.situacao = situacao;
            }
        },
        salvar() {
            this.isLoading = true;
            this.isLoadingEdit = true;
            this.regiao = this.mapTosave(this.regiao);
            if (this.validation.validate(this.regiao, this.$refs)) {
                this.regiao.idempresa = this.empresa.id;
                this.regiao.situacao = this.situacao.id;
                this.regiao.reajustecif =
                    this.regiao.reajustecif === '' ? 0 : this.regiao.reajustecif;
                this.regiao.reajustefob =
                    this.regiao.reajustefob === '' ? 0 : this.regiao.reajustefob;
                this.regiao.valorminimofob =
                    this.regiao.valorminimofob === '' ? 0 : this.regiao.valorminimofob;
                this.regiao.valorminimocif =
                    this.regiao.valorminimocif === '' ? 0 : this.regiao.valorminimocif;
                this.regiao.ticketmedio =
                    this.regiao.ticketmedio === '' ? 0 : this.regiao.ticketmedio;
                this.isSaving = true;
                this.service
                    .save(this.regiao)
                    .then((body) => {
                        if (body.content) {
                            let msg = 'msg-regiao-salva';
                            if (this.regiao.id) {
                                msg = 'msg-regiao-editada';
                            }
                            this.regiao = body.content;
                            this.msgs.push(new Message('success', msg, true));
                            this.isSaving = false;
                            this.redirectToList(2);
                        } else {
                            if (this.$te(body.message)) {
                                if (body.message == 'msg-codigo-duplicado-n') {
                                    this.msgs.push(
                                        new Message(
                                            'alert',
                                            this.$t(body.message, { n: this.regiao.idregiaoerp }),
                                            true,
                                            false
                                        )
                                    );
                                } else {
                                    this.msgs.push(new Message('alert', body.message, true));
                                }
                            } else {
                                this.msgs.push(
                                    new Message('error', 'msg-problema-realizar-acao', true)
                                );
                            }
                        }

                        this.isSaving = false;
                    })
                    .catch((e) => {
                        if (this.$te(e.message)) {
                            if (e.message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        'alert',
                                        this.$t(e.message, { n: this.regiao.idregiaoerp }),
                                        true,
                                        false
                                    )
                                );
                            } else {
                                this.msgs.push(new Message('alert', e.message, true));
                            }
                        } else {
                            this.msgs.push(
                                new Message('error', 'msg-problema-realizar-acao', true)
                            );
                        }
                        this.isSaving = false;
                    })
                    .finally(() => {
                        this.isLoading = false;
                        this.isLoadingEdit = false;
                    });
            } else {
                this.isLoading = false;
                this.isLoadingEdit = false;
            }
        },
        redirectToList(time) {
            this.isChanged = false;
            setTimeout(() => {
                this.$router.push({
                    name: this.isVenda || this.isAgro ? `${this.abrev}-regiao` : 'regioes',
                });
            }, time * 1000 + 50);
        },
        getLabel(option) {
            if (option.label != undefined) {
                return this.$t(option.label);
            } else {
                return this.$t(option);
            }
        },
        validatePorcCif() {
            this.invalidPorcentagemCif = !this.validatePorcentagem(this.regiao.reajustecif);
        },
        validatePorcFob() {
            this.invalidPorcentagemFob = !this.validatePorcentagem(this.regiao.reajustefob);
        },
        resize() {
            this.isMobile = window.innerWidth <= 768;
        },
        /*
        @84626
        sretornar empresas que estão associadas a um usuário informado. Caso o usuário for admin,
        retorna todas as empresas
    */
        carregarEmpresas(q) {
            this.empresasLoading = true;
            this.empresaService
                .findList(q)
                .then((r) => {
                    if (r.status != 200) {
                        console.error(`[REGIAO] Erro status ${r.status} ao carregar empresas.`);
                        console.error(`[REGIAO] Mensagem: ${r.message}`);
                    } else {
                        return r.content.map((e) => {
                            return {
                                id: e.idempresa,
                                label: e.nome,
                            };
                        });
                    }
                })
                .then((res) => {
                    if (res != null) this.empresas.push(...res);
                })
                .catch((e) => {
                    console.error('[REGIAO] Erro ao carregar empresas.', e);
                })
                .finally((_) => {
                    this.empresasLoading = false;
                });
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;

    .page {
        position: relative;
    }
}
</style>
